import { render, staticRenderFns } from "./EntranceSessionReportRegisters.vue?vue&type=template&id=e9ad369c"
import script from "./EntranceSessionReportRegisters.vue?vue&type=script&lang=js"
export * from "./EntranceSessionReportRegisters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports